<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      Card
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>

      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search: Family Eye Card"
          single-line
          hide-details
          outlined
          dense
      ></v-text-field>
    </v-card-title>
    <v-card>
      <v-data-table
          :headers="headers"
          :items="desserts"
          :loading="loading"
          :server-items-length="totalItems"
          :options.sync="options"
          class="elevation-1"
          @update:options="familyEyeCardList"
          disable-pagination
          :hide-default-footer="true"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }" v-if="item.status=='active'">
              <v-icon
                @click="cardDetails(item)"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                outlined
              >
                mdi-eye
              </v-icon>
            </template>
            <span>Card Details</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>


      <v-container>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="4">
            <v-pagination
                v-model="options.page"
                :length="totalPages"
                class="mt-4"
                @input="familyEyeCardList"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      search: "",
      sortBy: "operation.name",
      sortDesc: false,
      totalItems: 0,
      totalPages: 0,
      lastPage: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      loadingstatus: true,
      loading: true,
      headers: [
        { text: "Card No", value: "card_no" },
        { text: "Card Type", value: "card_type.name" },
        { text: "CashBack", value: "card_type.cashback_amount" },
        { text: "Card Holder Name", value: "patient.patient_name" },
        { text: "Phone", value: "patient.patient_phone" },
        { text: "Address", value: "patient.patient_address" },
        { text: "Active Date", value: "active_date" },
        { text: "Status", value: "status" },
        { text: "Action", value: "actions" },
      ],
      actions: [
        {
          type: "edit",
          key: ["Description"],
          func: this.updatePayment,
          icon: "edit",
        },
      ],

      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Patients",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize();
  },
  watch: {
    options: {
      handler() {
        this.familyEyeCardList(); // Fetch data when pagination options change
      },
      deep: true,
    },
    search() {
      this.familyEyeCardList();
    }
  },
  methods: {
    initialize() {
      this.loading = true
      this.familyEyeCardList();
    },


    async familyEyeCardList() {
      this.loading = true
      this.desserts = [];
      await atshq
          .get("card/card", {
            params: {
              page: this.options.page,
              itemsPerPage: this.options.itemsPerPage,
              search: this.search,
            }
          })
          .then((response) => {
            this.desserts = response.data.eye_card_list.data;
            this.totalItems = response.data.eye_card_list.total;
            this.totalPages = response.data.eye_card_list.last_page;
            this.loading = false;
          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
            this.loading = false;
          });
    },

    getColor(status) {
      if (status == "open") return "orange";
      else return "green";
    },
    user_ledger(item) {
      var today = new Date();

      today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      window.open(
        this.returnUrl +
          "printdoc/invoice_list/" +
          this.date +
          "/" +
          item.user.id
      );
    },
    dateSelect(date) {
      this.loadingstatus = true;
      this.initialize(date);
    },
    cardDetails(item) {
      window.location.href = "card/details/" + item.card_no;
    },
  },
};
</script>